import React from "react";
import "./OceShaTestimonials.css";

interface Testimonial {
  quote: string;
  name: string;
  role: string;
  initial: string;
  featured?: boolean;
}

const testimonials: Testimonial[] = [
  {
    quote:
      "I went from an idea to a complete course in minutes. What would normally take days of outlining and writing was already structured and ready for me to review.",
    name: "Michael",
    role: "Course Creator",
    initial: "M",
    featured: true,
  },
  {
    quote:
      "Being able to control how closely AI follows my own material is incredibly useful. I can keep the course faithful to my expertise or let AI add examples and depth.",
    name: "Jennifer",
    role: "Professional Trainer",
    initial: "J",
  },
  {
    quote:
      "What makes OceSha different is that the AI doesn't stop after creating the course. It actually teaches the lessons and answers questions from students.",
    name: "Sarah",
    role: "Business Coach",
    initial: "S",
  },
  {
    quote:
      "The multilingual teaching capability opens up an entirely different opportunity for us. We can create the course once and reach students in different languages.",
    name: "Amanda",
    role: "Education Director",
    initial: "A",
    featured: true,
  },
  {
    quote:
      "I already had years of material, but turning it into a course always felt overwhelming. OceSha gave me a way to use what I'd already created and turn it into something I could actually sell.",
    name: "David",
    role: "Author & Consultant",
    initial: "D",
  },
  {
    quote:
      "OceSha gives me a way to turn what I know into a real business—create the course, teach it with AI, sell it, and then market it from the same platform.",
    name: "James",
    role: "Entrepreneur",
    initial: "J",
  },
  {
    quote:
      "I didn't have any course material prepared. I simply described the course I wanted to create, and OceSha built it for me.",
    name: "Marcus",
    role: "Entrepreneur",
    initial: "M",
    featured: true,
  },
  {
    quote:
      "I love that I can turn one course into blogs, social posts, video clips, images and infographics instead of constantly figuring out what to create next.",
    name: "Nicole",
    role: "Marketing Consultant",
    initial: "N",
  },
];

interface OceShaTestimonialsProps {
  onStartFreeClick?: () => void;
}

const OceShaTestimonials: React.FC<OceShaTestimonialsProps> = ({
  onStartFreeClick,
}) => {
  return (
    <section
      className="octesti-section"
      aria-labelledby="octesti-heading"
    >
      <div className="octesti-card">
        <div className="octesti-content">

          {/* Eyebrow */}
          <div className="octesti-eyebrow">
            Real customer experiences
          </div>

          {/* Heading */}
          <h2
            id="octesti-heading"
            className="octesti-h2"
          >
            What People{" "}
            <span className="octesti-gradient">
              Love About OceSha
            </span>
          </h2>

          {/* Intro */}
          <p className="octesti-intro">
            Hear directly from creators, trainers, educators,
            consultants, and entrepreneurs using OceSha to turn
            their knowledge into courses, teaching experiences,
            and businesses.
          </p>

          {/* Testimonials */}
          <div className="octesti-grid">
            {testimonials.map((t) => (
              <article
                className={`octesti-testimonial-card${
                  t.featured
                    ? " octesti-featured"
                    : ""
                }`}
                key={`${t.name}-${t.role}`}
              >
                <div
                  className="octesti-quote-mark"
                  aria-hidden="true"
                >
                  &ldquo;
                </div>

                <blockquote>
                  {t.quote}
                </blockquote>

                <div className="octesti-person">
                  <div
                    className="octesti-avatar"
                    aria-hidden="true"
                  >
                    {t.initial}
                  </div>

                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Existing Start Free button */}
          <div className="octesti-cta-row">
            <button
              className="octesti-cta"
              type="button"
              onClick={onStartFreeClick}
            >
              Start Free
              <span>→</span>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OceShaTestimonials;